import React from 'react';
import {TextField, UrlField} from "components/Form/Form/Field";
import {LinkIcon, PlusIcon, TagIcon, TrashIcon} from "@heroicons/react/solid";
import Button from "components/Button";
import {FieldArray, FieldArrayConfig, FieldArrayRenderProps} from "formik";
import {LinkAPIData} from "types/Link";

export type LinkListFieldProps = FieldArrayConfig & {
  required?: boolean
}

function LinkListField({required, ...props}: LinkListFieldProps) {
  return (
    <FieldArray {...props}>
      {({push, remove, form}: FieldArrayRenderProps) => {

        const links = form.values[props.name] as Array<LinkAPIData> | undefined

        return (
          <>
            <ul className='flex flex-col gap-3'>
              {links?.map((link, index) => (
                <li key={index} className="mb-2 flex space-x-4">
                  <div className="w-full grid grid-cols-6 gap-x-3">

                    <div className="col-span-3 sm:col-span-3">
                      <TextField
                        name={`${props.name}.${index}.text`}
                        label='Name *'
                        hint='250 chars max'
                        icon={TagIcon}
                        maxLength={250}
                        autoComplete="off"
                        required={required}
                      />
                    </div>

                    <div className="col-span-3 sm:col-span-3">
                      <UrlField
                        name={`${props.name}.${index}.url`}
                        label='Link *'
                        icon={LinkIcon}
                        maxLength={250}
                        autoComplete="off"
                        required={required}
                      />
                    </div>
                  </div>

                  <div className="translate-y-8">
                    <Button
                      size={Button.sizes.X_SMALL}
                      color={Button.colors.WHITE}
                      icon={TrashIcon}
                      onClick={() => remove(index)}
                    />
                  </div>
                </li>
              ))}
            </ul>

            <div className={links?.length ? 'mt-4' : ''}>
              <Button
                color={Button.colors.SECONDARY}
                icon={PlusIcon}
                size={Button.sizes.TINY}
                onClick={() => push({text: '', url: ''})}
              >
                Add Link
              </Button>
            </div>
          </>
        )
      }}
    </FieldArray>
  );
}

export default LinkListField;